import { PropertyData } from '@aloft/toolkit-shared';

import { PropertyGridSection } from '../../../components/PropertyGrid/columnSections/PropertyGridSection.tsx';
import {
  PropertyGridField,
  PropertyGridSectionProps,
} from '../../../components/PropertyGrid/types.ts';

export const AdjustmentsGridDateOfSaleSection = (props: PropertyGridSectionProps) => {
  const dateOfSaleField: PropertyGridField<PropertyData['editableData']['transaction']> = {
    fieldName: 'editableData.transaction',
    label: 'Date of Sale',
    manualAdjustmentKey: 'dateOfSale',
    toDisplayValue: (transaction) => {
      if (!transaction) return undefined;

      const { saleDate, contractDate } = transaction ?? {};

      if (!saleDate || !contractDate) return undefined;
      return `s${saleDate};c${contractDate}`;
    },
  };

  return (
    <PropertyGridSection
      {...props}
      title="Date of Sale Adjustments"
      fields={[
        {
          fieldName: 'editableData.transaction.concessions',
          label: 'Fin. Concessions',
          manualAdjustmentKey: 'concessions',
        },
        dateOfSaleField,
      ]}
    />
  );
};
